import React, { useState, useEffect } from 'react';
import { usePopper } from 'react-popper';
import '../../../../primitives/Box/Box.es.js';
import '../../../../primitives/Center/styled.es.js';
import '../../../../primitives/Group/Group.es.js';
import '../../../../primitives/Grid/Grid.es.js';
import '../../../../primitives/Level/Level.es.js';
import '../../../../primitives/Shelf/Shelf.es.js';
import { Portal } from '../../../../primitives/Portal/Portal.es.js';
import '../../../../primitives/Hidden/Hidden.es.js';
import '../../../../primitives/Media/Media.es.js';
import '../../../../primitives/Dialog/Dialog.es.js';
import '../../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../../primitives/Popper/Popper.es.js';
import '../../../../primitives/DragHandle/DragHandle.es.js';
import '../../../../primitives/Pin/Pin.es.js';
import { forwardRef } from '../../../../system/forwardRef.es.js';
import '../../../../utils/assertions.es.js';
import { mergeRefs } from '../../../../utils/refs.es.js';
import '../../../../utils/responsive.es.js';
import '../../../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Fade } from '../../../Fade/Fade.es.js';
import { matchWidth } from '../../../../primitives/Popper/modifiers.es.js';
import { useAutocompleteDropdown } from './AutocompleteContext.es.js';
import { Dropdown as Dropdown$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const popperOptions = {
  placement: "bottom-start",
  modifiers: [
    matchWidth,
    {
      name: "flip",
      options: {
        padding: 8
      }
    }
  ]
};
const Dropdown = forwardRef((props, ref) => {
  const _a = props, { children, anchorRef } = _a, rest = __objRest(_a, ["children", "anchorRef"]);
  const [popperElement, setPopperElement] = useState(null);
  const { isOpen } = useAutocompleteDropdown();
  const { styles, attributes, update } = usePopper(anchorRef, popperElement, popperOptions);
  const dropdownRef = mergeRefs(ref, setPopperElement);
  useEffect(() => {
    if (!isOpen)
      return;
    update == null ? void 0 : update();
  }, [isOpen, update]);
  return /* @__PURE__ */ React.createElement(Portal, {
    zIndex: 1001
  }, /* @__PURE__ */ React.createElement(Fade, {
    in: isOpen,
    timeout: isOpen ? 100 : 0
  }, /* @__PURE__ */ React.createElement(Dropdown$1, __spreadValues(__spreadValues({
    ref: dropdownRef,
    style: __spreadProps(__spreadValues({}, styles.popper), { maxHeight: props.maxHeight })
  }, attributes.popper), rest), children)));
});

export { Dropdown };
//# sourceMappingURL=Dropdown.es.js.map
